module.exports = __webpack_public_path__ + "static/media/favicon.2fabac35.ico";